import { FormikProps } from 'formik';
import { KeyboardEvent } from 'react';

const useEnterToSubmit = <T = any>(formRef: FormikProps<T>) => (ev: KeyboardEvent<HTMLFormElement>) => {
  if (ev.key.toLowerCase() === 'enter') {
    formRef.submitForm();
  }
};

export { useEnterToSubmit };
